// store.js
import { reactive } from 'vue'

export const user = reactive({
  access_token: '',
  nickname: '',
  avatar_url: '',
  is_high_quality: false,
})
